import { render, staticRenderFns } from "./exams-dashboard-component.vue?vue&type=template&id=361e3b74&scoped=true&"
import script from "./exams-dashboard-component.vue?vue&type=script&lang=ts&"
export * from "./exams-dashboard-component.vue?vue&type=script&lang=ts&"
import style0 from "./exams-dashboard-component.vue?vue&type=style&index=0&id=361e3b74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361e3b74",
  null
  
)

export default component.exports